import React, {useState} from "react";
import DHTextFieldSmall from "../../general/DHTextFieldSmall";
import DHDefaultDrawer from "../../general/DHDefaultDrawer";
import DHSwitch from "../../general/DHSwitch";
import {InputTextarea} from "primereact/inputtextarea";


export default function EventVeranstalterZusatzdatenComp({
                                                             eventOperatorId,
                                                             publishTournament,
                                                             online,
                                                             scoringWithDarthelfer,
                                                             anwesenheitspruefungScorer,
                                                             registrationAllowed,
                                                             deleteUnconfirmedRegistrations,
                                                             bezahlung,
                                                             bezahlungbetrag,
                                                             participantsMailConfirmation,
                                                             mailtext,
                                                             isEventGestartet,
                                                             isEventAbgeschlossen,
                                                             onPublishTournament,
                                                             onOnline,
                                                             onScoringWithDarthelfer,
                                                             onAnwesenheitspruefungScorer,
                                                             onRegistrationAllowed,
                                                             onDeleteUnconfirmedRegistrations,
                                                             onBezahlung,
                                                             onBezahlungbetrag,
                                                             onParticipantsMailConfirmation,
                                                             onMailtext
                                                         }) {

    let [showPublishTournamentNotice, setShowPublishTournamentNotice] = useState(false);
    let [showScoringNotice, setShowScoringNotice] = useState(false);
    let [showAnwesenheitspruefungNotice, setShowAnwesenheitspruefungNotice] = useState(false);
    let [showAnmeldungPublicNotice, setShowAnmeldungPublicNotice] = useState(false);
    let [showAnmeldungUnbestaetigtNotice, setShowAnmeldungUnbestaetigtNotice] = useState(false);
    let [showBezahlungNotice, setShowBezahlungNotice] = useState(false);
    let [showBezahlungBetragNotice, setShowBezahlungBetragNotice] = useState(false);
    let [showMailNotice, setShowMailNotice] = useState(false);
    let [showOnlineNotice, setShowOnlineNotice] = useState(false);
    let [showTeilnahmePerMailNotice, setShowTeilnahmePerMailNotice] = useState(false);

    return <>
        <div style={{marginBottom: 10}}>
            <DHDefaultDrawer onClose={() => setShowPublishTournamentNotice(false)} show={showPublishTournamentNotice} title={"Hinweis"} children={
                <div style={{padding: 20}}>
                    <div style={{marginBottom: 5}}>Datenschutz und Anonymität ist uns sehr wichtig. Auf der öffentlichen
                        Turnierseite von Darthelfer kannst du dein Turnier anzeigen lassen. Bitte wähle dazu hier 'Ja'.
                    </div>
                </div>
            }/>
            <DHSwitch id="id-veroeffentlichen" value={publishTournament} onChange={() => onPublishTournament(!publishTournament)}
                      disabled={eventOperatorId === null || eventOperatorId === undefined || isEventAbgeschlossen}
                      label="Event veröffentlichen" required={false}/>
            <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
               onClick={(e) => setShowPublishTournamentNotice(!showPublishTournamentNotice)}/>
        </div>
        <div style={{marginBottom: 10}}>
            <DHDefaultDrawer onClose={() => setShowOnlineNotice(false)} show={showOnlineNotice} title={"Hinweis"} children={
                <div style={{padding: 20}}>
                    <div style={{marginBottom: 5}}>
                        Sofern du das Turnier als online markierst, wird dieses online über Darthelfer gespielt. In diesem Fall müssen sich DH Benutzer am Turnier anmelden und spielen
                        dieses Turnier gegen einen Onlinegegner.
                    </div>
                    <div style={{marginBottom: 5}}>
                        Offline ist für Turniere in deinem Vereinsheim oder Zuhause. In diesem Fall kannst du die Ergebnisse von Hand in DH eintragen. Über den DH-Client kann gespielt
                        werden, in diesem Fall werden die Ergebnisse automatisch eingetragen.
                    </div>
                    <div>
                        Bitte beachte die Option Scoring mit Scorer. Sofern du über den darthelfer-scorer spielen willst, muss diese Option gesetzt werden. Wenn nicht, musst du das
                        Ergebnis von Hand im Turnierbaum oder im Gruppenturnier eintragen.
                    </div>
                </div>
            }/>
            <DHSwitch id="id-veroeffentlichen" value={online} onChange={() => onOnline(!online)}
                      disabled={eventOperatorId === null || eventOperatorId === undefined || isEventGestartet || isEventAbgeschlossen}
                      label="Online" required={false}/>
            <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
               onClick={(e) => setShowOnlineNotice(!showOnlineNotice)}/>
            {online && <div style={{color: "red", marginBottom: 10}}>Bei Online werden die Spiele an unterschiedlichen Rechnern, z.B. einer in München und der andere in Berlin, ausgetragen.</div>}
        </div>
        {!online &&
            <div style={{marginBottom: 10}}>
                <DHDefaultDrawer onClose={() => setShowScoringNotice(false)} show={showScoringNotice} title={"Hinweis"} children={
                    <div style={{padding: 20}}>
                        <div style={{marginBottom: 5}}>
                            Sofern du dein Turnier mit Darthelfer scoren willst, wähle hier 'Ja'. Den
                            darthelfer-scorer findest du unter https://scorer.darthelfer.de
                        </div>
                        <div style={{marginBottom: 5}}>
                            Hilfen dazu findest du unter support.darthelfer.de oder auf der Startseite von
                            darthelfer.de
                        </div>
                    </div>
                }/>
                <DHSwitch id="id-scoringmitdarthelfer" value={scoringWithDarthelfer} onChange={() => onScoringWithDarthelfer(!scoringWithDarthelfer)}
                          disabled={eventOperatorId === null || eventOperatorId === undefined || isEventGestartet || isEventAbgeschlossen}
                          label="Scoring mit Scorer" required={false}/>
                <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                   onClick={(e) => setShowScoringNotice(!showScoringNotice)}/>
            </div>
        }
        {!online && onAnwesenheitspruefungScorer &&
            <div style={{marginBottom: 10}}>
                <DHDefaultDrawer onClose={() => setShowAnwesenheitspruefungNotice(false)} show={showAnwesenheitspruefungNotice} title={"Hinweis"} children={
                    <div style={{padding: 20}}>
                        <div style={{marginBottom: 5}}>
                            Wähle 'Ja', wenn am Scorer geprüft werden soll, ob die Teilnehmer und evtl. ein vorhandener Schreiber anwesend sind.
                        </div>
                        <div style={{marginBottom: 5}}>
                            Du kannst damit im Adminbereich erkennen, ob ein Spieler oder Schreiber fehlt und kannst darauf reagieren.
                        </div>
                        <div style={{marginBottom: 5}}>
                            Diese Option ist nur möglich, wenn 'Scoring mit Scorer' gewählt ist.
                        </div>
                    </div>
                }/>
                <DHSwitch id="id-anwesenheitspruefungscorer" value={scoringWithDarthelfer && anwesenheitspruefungScorer}
                          onChange={() => onAnwesenheitspruefungScorer(!anwesenheitspruefungScorer)}
                          disabled={eventOperatorId === null || eventOperatorId === undefined || !scoringWithDarthelfer || isEventGestartet || isEventAbgeschlossen}
                          label="Anwesenheitsprüfung am Scorer" required={false}/>
                <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                   onClick={(e) => setShowAnwesenheitspruefungNotice(!showAnwesenheitspruefungNotice)}/>
            </div>
        }
        <div style={{marginBottom: 10}}>
            <DHDefaultDrawer onClose={() => setShowAnmeldungPublicNotice(false)} show={showAnmeldungPublicNotice} title={"Hinweis"} children={
                <div style={{padding: 20}}>
                    <div style={{marginBottom: 5}}>
                        Wähle 'Ja', wenn die Anmeldung zu deinem Turnier durch den Teilnehmer möglich ist.
                    </div>
                    <div style={{marginBottom: 5}}>
                        Wähle 'Nein', wenn du die Teilnehmer selbst eintragen möchtest. In diesem Fall ist eine Anmeldung über die darthelfer-Turnierübersicht nicht möglich. Nur du und
                        deine Admins könnt Teilnehmer hinzufügen.
                    </div>
                </div>
            }/>
            <DHSwitch id="id-anmeldungmoeglich" value={registrationAllowed} onChange={() => onRegistrationAllowed(!registrationAllowed)}
                      disabled={eventOperatorId === null || eventOperatorId === undefined || isEventGestartet || isEventAbgeschlossen}
                      label="Anmeldung möglich" required={false}/>
            <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
               onClick={(e) => setShowAnmeldungPublicNotice(!showAnmeldungPublicNotice)}/>
        </div>
        <div style={{marginBottom: 10}}>
            <DHDefaultDrawer onClose={() => setShowAnmeldungUnbestaetigtNotice(false)} show={showAnmeldungUnbestaetigtNotice} title={"Hinweis"} children={
                <div style={{padding: 20}}>
                    <div style={{marginBottom: 5}}>
                        Wähle 'Ja', wenn du die Anmeldung vom System automatisch löschen lassen willst, sofern der Teilnehmer die Anmeldung in der Mail nicht bestätigt (Aktuell nach 24
                        Std.). Die soll SPAM-Anmeldungen verhinden.
                    </div>
                    <div style={{marginBottom: 5}}>
                        Wähle 'Nein', Anmeldung wird nicht automatisch vom System gelöscht.
                    </div>
                </div>
            }/>
            <DHSwitch id="id-anmeldungmoeglich" value={deleteUnconfirmedRegistrations} onChange={() => onDeleteUnconfirmedRegistrations(!deleteUnconfirmedRegistrations)}
                      disabled={eventOperatorId === null || eventOperatorId === undefined || isEventGestartet || isEventAbgeschlossen}
                      label="Unbestätigte Anmeldung löschen" required={false}/>
            <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
               onClick={(e) => setShowAnmeldungUnbestaetigtNotice(!showAnmeldungUnbestaetigtNotice)}/>
        </div>
        <div style={{marginBottom: 10}}>
            <DHDefaultDrawer onClose={() => setShowTeilnahmePerMailNotice(false)} show={showTeilnahmePerMailNotice} title={"Hinweis"} children={
                <div style={{padding: 20}}>
                    <div style={{marginBottom: 5}}>
                        Wähle 'Ja', wenn Teilnehmer Ihre Teilnahme bestätigen müssen. Die Teilnehmer erhalten nach der Anmeldung eine Mail und müssen innerhalb eines kurzen Zeitraums
                        die Teilnahme bestätigen.
                    </div>
                    <div style={{marginBottom: 5}}>
                        Wähle 'Nein', wenn die Teilnahme nicht per Mail bestätigt werden muss. In diesem Fall hast du das Risiko, dass ein Roboter oder eine Person die Anmeldung
                        durchführt und du evtl. Teilnehmer gemeldet hast die nicht die Absicht haben mitzuspielen.
                    </div>
                </div>
            }/>
            <DHSwitch id="id-anmeldungmoeglich" value={participantsMailConfirmation} onChange={() => onParticipantsMailConfirmation(!participantsMailConfirmation)}
                      disabled={eventOperatorId === null || eventOperatorId === undefined || isEventGestartet || isEventAbgeschlossen}
                      label="Teilnahme per Mail bestätigen" required={false}/>
            <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
               onClick={(e) => setShowTeilnahmePerMailNotice(!showTeilnahmePerMailNotice)}/>
        </div>
        <div style={{marginBottom: 10}}>
            <DHDefaultDrawer onClose={() => setShowBezahlungNotice(false)} show={showBezahlungNotice} title={"Hinweis"} children={
                <div style={{padding: 20}}>
                    <div style={{marginBottom: 5}}>
                        Sofern für die Turnierteilnahme eine Gebühr notwendig ist, stelle hier auf 'Ja'. Im Mailtext kannst du dann deine Infos dafür angeben.
                    </div>
                </div>
            }/>
            <DHSwitch id="id-anmeldungmoeglich" value={bezahlung} onChange={() => onBezahlung(!bezahlung)}
                      disabled={eventOperatorId === null || eventOperatorId === undefined || isEventGestartet || isEventAbgeschlossen}
                      label="Bezahlung" required={false}/>
            <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
               onClick={(e) => setShowBezahlungNotice(!showBezahlungNotice)}/>
        </div>
        {bezahlung &&
            <div style={{marginBottom: 10}}>
                <DHDefaultDrawer onClose={() => setShowBezahlungBetragNotice(false)} show={showBezahlungBetragNotice} title={"Hinweis"} children={
                    <div style={{padding: 20}}>
                        <div style={{marginBottom: 5}}>
                            Bezahlbetrag. Dieser muss für die Turnierteilnahme entrichtet werden. Wir fügen diese
                            Info einer entsprechenden Bestätigungsmail hinzu.
                        </div>
                    </div>
                }/>
                <div style={{display: "flex", alignContent: "center", alignItems: "center"}}>
                    <DHTextFieldSmall id="id-bezahlbetrag" width={200} value={bezahlungbetrag} onChange={(text) => onBezahlungbetrag(text)} label="Bezahlbetrag"
                                      disabled={eventOperatorId === null || eventOperatorId === undefined || isEventGestartet || isEventAbgeschlossen}/>
                    <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                       onClick={(e) => setShowBezahlungBetragNotice(!showBezahlungBetragNotice)}/>
                </div>
            </div>
        }
        {participantsMailConfirmation &&
            <div style={{marginBottom: 10}}>
                <DHDefaultDrawer onClose={() => setShowMailNotice(false)} show={showMailNotice} title={"Hinweis"} children={
                    <div style={{padding: 20}}>
                        <div style={{marginBottom: 5}}>
                            Der gesamte Text wird in der Bestätigungsmail eingefügt.
                        </div>
                        <div style={{marginBottom: 5}}>
                            Füge in den Text eventuelle Bezahlinformationen wie Bankdaten oder PayPal Infos ein. Sofern der Betrag gefühlt ist, fügen wir dies Information automatisch
                            hinzu.
                        </div>
                    </div>
                }/>
                <div className="col-fixed" style={{width: 220}}>Mailtext:
                    <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}}
                       onClick={(e) => setShowMailNotice(!showMailNotice)}/>
                </div>
                <div className="col-fixed" style={{width: 220}}>
                    <div className="col" style={{width: "100%"}}>
                        <InputTextarea rows={5} cols={50} maxLength={5000} value={mailtext}
                                       disabled={eventOperatorId === null || eventOperatorId === undefined || isEventGestartet || isEventAbgeschlossen}
                                       onChange={(e) => onMailtext(e.target.value)}/>
                    </div>
                </div>
            </div>
        }
    </>
}